export default "__VITE_ASSET__162c4fdb__"